<template>
  <b-card header="Charge Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
    <div v-if="!e_charges" class="row">
      <div class="col-12">
        <p class="font-weight-bold pt-0 mb-3">All Charges are based on a per worker per week basis.</p>
      </div>
      <!-- Genius Charge Agreed -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="genius_charge_agreed"><span v-if="isPayrollCrm">Genius Charge</span><span v-else>V3 Margin</span> Agreed</label>
        <p id="genius_charge_agreed" v-html="return_fee_margin_agreed"></p>
      </div>
      <!-- Genius Charge type -->
      <div v-if="isFeeMarginAgreed" class="col-xl-4 form-group">
        <label class="form-label" for="genius_charge_type"><span v-if="isPayrollCrm">Genius Admin Fee</span><span v-else>V3 Margin</span> Type</label>
        <p id="genius_charge_type" v-html="return_fee_margin_type"></p>
      </div>
      <!-- Genius Charge value -->
      <div v-if="isFeeMarginAgreed" class="col-xl-4 form-group">
        <label class="form-label" for="genius_charge_value"><span v-if="isPayrollCrm">Genius Admin Fee</span><span v-else>V3 Margin</span> value</label>
        <p id="genius_charge_value" v-html="return_fee_margin_amount"></p>
      </div>
      <!-- Public Employers Insurance -->
      <div v-if="isFeeMarginAgreed && isPayrollCrm" class="col-xl-4 form-group">
        <label class="form-label" for="pe_insurance">PE Insurance Included</label>
        <p id="pe_insurance" v-html="return_payroll_pe_insurance"></p>
      </div>
      <!-- Worker Personal Accident Insurance -->
      <div v-if="isFeeMarginAgreed && isPayrollCrm" class="col-xl-4 form-group">
        <label class="form-label" for="pa_insurance">Worker PA Insurance Included</label>
        <p id="pa_insurance" v-html="return_payroll_pa_insurance"></p>
      </div>

      <!-- FEE TOTAL DISPLAYED -->
      <div class="col-12" v-if="isFeeMarginAgreed">
        <div style=" border: 1px solid #333333; text-align: center" class="mb-4 mt-2">
          <div v-if="payment_process_info.fee_margin_type === '£ (Pound)'" style="font-weight: bold; font-size: 1.5rem;">
            TOTAL FEE =
            <!-- PE + PA -->
            <span v-if="isPayrollPeInsurance && isPayrollPaInsurance" class="bp_color">{{ return_payroll_pe_and_pa }} (PE &amp; PA Insurance)</span>
            <!-- PE + !PA -->
            <span v-else-if="isPayrollPeInsurance && !isPayrollPaInsurance" class="bp_color">{{ return_payroll_pe_not_pa }} (PE Insurance)</span>
            <!-- !PE + PA -->
            <span v-else-if="!isPayrollPeInsurance && isPayrollPaInsurance" class="bp_color">{{ return_payroll_pa_not_pe }} (PA Insurance)</span>
            <!-- !PE + !PA -->
            <span v-else-if="!isPayrollPeInsurance && !isPayrollPaInsurance" class="bp_color">{{ return_payroll_not_pe_not_pa }}</span>
          </div>
          <div v-else-if="payment_process_info.fee_margin_type === '% (Percentage)'" style="font-weight: bold; font-size: 1.5rem;">
            TOTAL FEE = <span class="bp_color" v-html="return_fee_margin_amount"></span>
            <!-- PE + PA -->
            <span v-if="isPayrollPeInsurance && isPayrollPaInsurance" class="bp_color"> + {{ (parseFloat(pe_ins) + parseFloat(pa_ins)) | currency }} (PE &amp; PA Insurance)</span>
            <!-- PE + !PA -->
            <span v-else-if="isPayrollPeInsurance && !isPayrollPaInsurance" class="bp_color"> + {{ (parseFloat(pe_ins)) | currency }} (PE Insurance)</span>
            <!-- !PE + PA -->
            <span v-else-if="!isPayrollPeInsurance && isPayrollPaInsurance" class="bp_color"> + {{ (parseFloat(pa_ins)) | currency }} (PA Insurance)</span>
          </div>
        </div>
      </div>

      <div class="col-12 text-right" v-if="ifNotCompanyContactUser">
        <button @click="edit_form()" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Edit Charges</button>
      </div>
    </div>
    <div v-else-if="e_charges" class="row">
      <ValidationObserver ref="editChargesForm" slim tag="div" class="col-12">
        <form role="form" @submit.prevent="submit_form">
          <div class="row">
            <div class="col-12">
              <p class="font-weight-bold pt-0 mb-3">All Charges are based on a per worker per week basis.</p>
            </div>
            <!-- Admin Fee Agreed -->
            <div class="col-xl-4">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_fee_margin_agreed">
                  <span v-if="isPayrollCrm">Genius Charge</span><span v-else>V3 Margin</span> Agreed</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_charges.fee_margin_agreed" id="edit_fee_margin_agreed" name="edit_fee_margin_agreed"
                                    :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <!-- Genius Charge type -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Admin Fee type" tag="div" class="col-xl-4 form-group"
                                v-if="edit_charges.fee_margin_agreed">
              <label class="form-label" for="edit_fee_type"><span v-if="isPayrollCrm">Genius Admin Fee</span><span v-else>V3 Margin</span> type</label>
              <multiselect v-model="edit_charges.fee_margin_type" id="edit_fee_type" name="edit_fee_type" placeholder="" :options="ms_opts.fee_type"
                           :class="classes" label="value" track-by="id" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Genius Charge value -->
            <ValidationProvider rules="decimal" v-slot="{errors, classes}" name="Admin Fee Amount" tag="div" class="col-xl-4 form-group"
                                v-if="edit_charges.fee_margin_agreed">
              <label class="form-label" for="edit_admin_fee_amount"><span v-if="isPayrollCrm">Genius Admin Fee</span><span v-else>V3 Margin</span> Amount</label>
              <div class="input-group">
                <div v-if="edit_charges.fee_margin_type !== null && edit_charges.fee_margin_type.value === '£ (Pound)'"
                     class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                <div v-else-if="edit_charges.fee_margin_type !== null && edit_charges.fee_margin_type.value === '% (Percentage)'"
                     class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                <input type="text" v-model="edit_charges.fee_margin_amount" id="edit_admin_fee_amount" name="edit_admin_fee_amount" class="form-input">
              </div>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Public Employers Insurance -->
            <div v-if="edit_charges.fee_margin_agreed && isPayrollCrm" class="col-xl-4">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_pe_insurance">P.E. Insurance</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_charges.payroll_pe_insurance" id="edit_pe_insurance" name="edit_pe_insurance"
                                    :options="{ on: 'Yes', off: 'No' }"/>
                </div>
                <div v-if="edit_charges.payroll_pe_insurance" class="col-12">
                  <p class="pt-0 mb-3 text-right font-weight-bold">A Charge of {{ pe_ins | currency }} for P.E. Insurance will be made on top of the agreed Admin Charge</p>
                </div>
              </div>
            </div>
            <!-- Personal Accident Insurance -->
            <div v-if="edit_charges.fee_margin_agreed && isPayrollCrm" class="col-xl-4">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_payroll_pa_insurance">P.A. Insurance</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_charges.payroll_pa_insurance" id="edit_payroll_pa_insurance" name="edit_payroll_pa_insurance"
                                    :options="{ on: 'Yes', off: 'No' }"/>
                </div>
                <div v-if="edit_charges.payroll_pa_insurance" class="col-12">
                  <p class="pt-0 mb-3 text-right font-weight-bold">A Charge of {{ pa_ins | currency }} for P.A. Insurance will be made on top of the
                                                                   agreed Admin Charge</p>
                </div>
              </div>
            </div>

            <div class="col-12" v-if="edit_charges.fee_margin_agreed && edit_charges.fee_margin_type !== null">
              <div style=" border: 1px solid #333333; text-align: center" class="mb-4 mt-2">
                <div v-if="edit_charges.fee_margin_type !== null && edit_charges.fee_margin_type.value === '£ (Pound)'" style="font-weight: bold; font-size: 1.5rem;">
                  TOTAL FEE =
                  <!-- PE + PA -->
                  <span v-if="edit_charges.payroll_pe_insurance && edit_charges.payroll_pa_insurance">
                          <span class="bp_color">
                            {{ parseFloat(edit_charges.fee_margin_amount) + (parseFloat(pe_ins) + parseFloat(pa_ins)) | currency }} (PE &amp; PA Insurance)
                          </span>
                        </span>
                  <!-- PE + !PA -->
                  <span v-else-if="edit_charges.payroll_pe_insurance && !edit_charges.payroll_pa_insurance">
                          <span class="bp_color">
                            {{ parseFloat(edit_charges.fee_margin_amount) + (parseFloat(pe_ins)) | currency }} (PE Insurance)
                          </span>
                        </span>
                  <!-- !PE + PA -->
                  <span v-else-if="!edit_charges.payroll_pe_insurance && edit_charges.payroll_pa_insurance">
                          <span class="bp_color">
                            {{ parseFloat(edit_charges.fee_margin_amount) + (parseFloat(pa_ins)) | currency }} (PA Insurance)
                          </span>
                        </span>
                  <!-- !PE + !PA -->
                  <span v-else-if="!edit_charges.payroll_pe_insurance && !edit_charges.payroll_pa_insurance">
                          <span class="bp_color">{{ parseFloat(edit_charges.fee_margin_amount) | currency }}</span>
                        </span>
                </div>
                <div v-else-if="edit_charges.fee_margin_type === '% (Percentage)'" style="font-weight: bold; font-size: 1.5rem;">
                  TOTAL FEE = <span class="bp_color">{{ parseFloat(edit_charges.fee_margin_amount) | percentage }}</span>
                  <!-- PE + PA -->
                  <span v-if="edit_charges.payroll_pe_insurance && edit_charges.payroll_pa_insurance">
                          + <span class="bp_color">
                          {{ (parseFloat(pe_ins) + parseFloat(pa_ins)) | currency }} (PE &amp; PA Insurance)
                        </span>
                        </span>
                  <!-- PE + !PA -->
                  <span v-else-if="edit_charges.payroll_pe_insurance && !edit_charges.payroll_pa_insurance">
                          + <span class="bp_color">{{ (parseFloat(pe_ins)) | currency }} (PE Insurance)</span>
                        </span>
                  <!-- !PE + PA -->
                  <span v-else-if="!edit_charges.payroll_pe_insurance && edit_charges.payroll_pa_insurance">
                          + <span class="bp_color">{{ (parseFloat(pa_ins)) | currency }} (PA Insurance)</span>
                        </span>
                </div>
              </div>
            </div>
          </div>
          <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
          <div class="row mb-3 mt-2">
            <div class="col-xl-6">
              <button @click.prevent="cancel_form()" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
            </div>
            <div class="col-xl-6">
              <button type="submit" class="btn orcaBtn sm_btn w-100">Update Charge Information</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-card>
</template>

<script>
import BootstrapToggle from 'vue-bootstrap-toggle';
import Multiselect from "vue-multiselect";

import { getChangedFields } from 'utils/utils';



export default {
  name: "charges",
  components: {
    BootstrapToggle,
    Multiselect
  },
  props: [
    'ifNotCompanyContactUser',
    'isPayrollCrm',
    'payment_process_info',
    'company'
  ],
  data() {
    return {
      pe_ins: process.env.MIX_PE_INS,
      pa_ins: process.env.MIX_PA_INS,
      e_charges: false,
      edit_charges: {},
      original_charges: {},
      ms_opts: {
        fee_type: this.$store.state.crm_options.fee_type,
      },
      latestSignedContract: null
    }
  },
  beforeMount() {
  },
  computed: {
    /**
     * If a fee/margin has been agreed
     * @returns {boolean}
     */
    isFeeMarginAgreed() {
      return this.payment_process_info.fee_margin_agreed
    },
    /**
     * Payroll CRM - If PE insurance has been offered to the company and is to be applied to the worker fee
     * @returns {boolean|*}
     */
    isPayrollPeInsurance() {
      return this.payment_process_info.payroll_pe_insurance
    },
    /**
     * Payroll CRM - If PA insurance has been offered to the company and is to be applied to the worker fee
     * @returns {boolean|*}
     */
    isPayrollPaInsurance() {
      return this.payment_process_info.payroll_pa_insurance
    },
    /**
     * Return value for if a fee/margin has been agreed with the company
     * @returns {string}
     */
    return_fee_margin_agreed() {
      if (this.payment_process_info.fee_margin_agreed) {
        return 'Yes'
      }
      else if (!this.payment_process_info.fee_margin_agreed) {
        return 'No'
      }
      else return "&nbsp;"
    },
    /**
     * Return the fee/margin type selected
     * @returns {null|*|string}
     */
    return_fee_margin_type() {
      return this.payment_process_info.fee_margin_type !== null ? this.payment_process_info.fee_margin_type : "&nbsp;"
    },
    /**
     * Return formatted fee/margin amount - based on the type of fee/margin selected
     * @returns {string|*}
     */
    return_fee_margin_amount() {
      if (this.payment_process_info.fee_margin_type === '£ (Pound)') {
        return this.$options.filters.currency(this.payment_process_info.fee_margin_amount)
      }
      else if (this.payment_process_info.fee_margin_type === '% (Percentage)') {
        return this.$options.filters.percentage(this.payment_process_info.fee_margin_amount);
      }
      else return "&nbsp;"
    },
    /**
     * Payroll CRM - Return wording for if PE insurance has been taken for workers by the company
     * @returns {string}
     */
    return_payroll_pe_insurance() {
      if (this.payment_process_info.payroll_pe_insurance) {
        return "Yes - <i>A Charge of " +
            this.$options.filters.currency(this.pe_ins) +
            " will be made on top of the agreed Admin Charge</i>"
      }
      else if (!this.payment_process_info.payroll_pe_insurance) {
        return 'No'
      }
      else return "&nbsp;"
    },
    /**
     * Payroll CRM - Return wording for if PA insurance has been taken for workers by the company
     * @returns {string}
     */
    return_payroll_pa_insurance() {
      if (this.payment_process_info.payroll_pa_insurance) {
        return "Yes - <i>A Charge of " +
            this.$options.filters.currency(this.pa_ins) +
            " will be made on top of the agreed Admin Charge</i>"
      }
      else if (!this.payment_process_info.payroll_pa_insurance) {
        return 'No'
      }
      else {
        return "&nbsp;"
      }
    },
    /* ---------------------------------------------------------------------------------------------------------
     * CALCULATED FEES - IF FEE/MARGIN TYPE = '£ (Pound)'
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * Currency formatted value of (Admin fee + pe + pa)
     * @returns {*}
     */
    return_payroll_pe_and_pa() {
      return this.$options.filters.currency(parseFloat(this.payment_process_info.fee_margin_amount) + (parseFloat(this.pe_ins) + parseFloat(this.pa_ins)))
    },
    /**
     * Currency formatted value of (Admin fee + pe)
     * @returns {*}
     */
    return_payroll_pe_not_pa() {
      return this.$options.filters.currency(parseFloat(this.payment_process_info.fee_margin_amount) + (parseFloat(this.pe_ins)))
    },
    /**
     * Currency formatted value of (Admin fee + PA)
     * @returns {*}
     */
    return_payroll_pa_not_pe() {
      return this.$options.filters.currency(parseFloat(this.payment_process_info.fee_margin_amount) + (parseFloat(this.pa_ins)))
    },
    /**
     * Currency formatted value of (Only Admin fee)
     * @returns {*}
     */
    return_payroll_not_pe_not_pa() {
      return this.$options.filters.currency(parseFloat(this.payment_process_info.fee_margin_amount))
    },
  },
  methods: {
    fetchLatestSignedContract() {
      axios.get(this.crmApiPath + 'company/latest_signed_contract/company/' + this.company.id).then(response => {
          if (response.data !== '') {
            this.latestSignedContract = response.data;
            this.pe_ins = 0;
            this.pa_ins = 0;
            if (this.latestSignedContract.pe_taken) {
              this.pe_ins = this.latestSignedContract.pe_amount;
            }
            if (this.latestSignedContract.pa_taken) {
              this.pa_ins = this.latestSignedContract.pa_amount;
            }
          }
      });
    },
    /**
     * Switch vue to show form to edit charge information
     * and set values on form
     */
    edit_form() {
      this.edit_charges = Object.assign({}, this.payment_process_info);
      this.original_charges = Object.assign({}, this.payment_process_info); 
      if (this.payment_process_info.fee_margin_type !== null) {
        this.edit_charges['fee_margin_type'] =
            this.$store.state.crm_options.fee_type.find(p => p.value === this.payment_process_info.fee_margin_type);
        this.original_charges['fee_margin_type'] = this.edit_charges['fee_margin_type'];
      }
      this.$nextTick(() => this.e_charges = true)
    },
    /**
     * Reset and hide the edit form
     */
    cancel_form() {
      this.edit_charges = {};
      this.e_charges = false;
    },
    /**
     * Submit the edit form values to the database and reload vue
     */
    submit_form() {
      this.$refs.editChargesForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editChargesForm);
        }
        else {
          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);
          let charges_promises = [];
          
          // Use the new function to get changed fields
          let changed_fields = [
            ...getChangedFields(this.original_charges, this.edit_charges),
         ];

          charges_promises.push(new Promise(resolve => {
            let submit_ppi = {
              company_id: this.company.id,
              fee_margin_agreed: this.edit_charges.fee_margin_agreed,
              fee_margin_type: null,
              fee_margin_amount: this.edit_charges.fee_margin_amount,
              payroll_pe_insurance: this.edit_charges.payroll_pe_insurance,
              payroll_pa_insurance: this.edit_charges.payroll_pa_insurance,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
            // if fee/margin type is selected format value to be saved to the database (value)
            if (this.edit_charges.fee_margin_type !== null && this.edit_charges.fee_margin_type !== undefined) {
              submit_ppi.fee_margin_type = this.edit_charges.fee_margin_type.value
            }
            // save updates to database
            axios.patch(this.crmApiPath + 'company/payment_process_info/' + this.edit_charges.id, submit_ppi).then(() => resolve());
          }));


          
          if (changed_fields.length > 0) {
            // Send changed fields through AJAX on email
            charges_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'company/send_changed_email', {
                title: 'CHARGE INFORMATION',
                company_id: this.company.id,
                changes: changed_fields,
              }).then(() => resolve());
            }));
          }



          // Once data has been saved reload vue and hide edit form
          Promise.all(charges_promises).then(() => {
            this.$bus.$emit('company::reload', {action: true});
            this.$bus.$emit('company_pre_agreement::reload', {action: true});
            this.$bus.$emit('company_payment_process::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            // close form
            this.$nextTick(() => {
              this.e_payment_info_process = false;
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
            })
          });
        }
      });
    }
  },
  watch: {
    'edit_charges.fee_margin_agreed'(val) {
      if (!val) {
        this.edit_charges.fee_margin_type = null;
        this.edit_charges.fee_margin_amount = '';
        if (this.crmType !== 'recruitment') {
          this.edit_charges.payroll_pe_insurance = true;
        }
      }
    },
    'edit_charges.payroll_require_payment_terms'(val) {
      if (!val) {
        this.edit_charges.payroll_payment_terms_length = ''
        this.edit_charges.payroll_payment_terms_perc = ''
      }
    },
    'edit_payment_process_info.recruitment_require_payment_terms'(val) {
      if (!val) {
        this.edit_charges.recruitment_payment_terms_length = ''
        this.edit_charges.recruitment_payment_terms_perc = ''
      }
    },
  }
}
</script>
